const withMessageCount = (Component) => {
  return (props) => {
    return <Component {...props} />;
  };
};

export default withMessageCount;
